import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import store from '@/store';
import CInput from '@/components/shared/CInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStylePropertiesCreateHeader',
  setup(__props) {

const searchInputRef = ref('');

const handleSearchInput = () => {
    store.dispatch('mapStyleProperties/updateSearchQuery', searchInputRef.value);
};

return { __sfc: true,searchInputRef, handleSearchInput, CInput }
}

})